import { useEffect, useState } from 'react'
import { fetchRedditEmbedInfo } from '../../api/reddit'
import { YouTubeEmbed } from './YouTubeEmbed'

interface Props {
  url: string
  path: string
}

export function RedditEmbed({ url, path }: Props) {
  const [youtubeVideoId, setYoutubeVideoId] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    fetchRedditEmbedInfo(url)
      .then((data) => { if (!cancelled) setYoutubeVideoId(data.youtube_video_id) })
      .catch(() => {})
    return () => { cancelled = true }
  }, [url])

  if (youtubeVideoId) return <YouTubeEmbed videoId={youtubeVideoId} />

  return (
    <div className="reddit-embed">
      <iframe
        src={`https://embed.reddit.com${path}?embed=true`}
        title="reddit post"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  )
}
